import React from 'react';
import { useSEO } from '../../hooks/useSEO';
import SectionHeading from '../../components/ui/SectionHeading';
import AnimatedSection from '../../components/ui/AnimatedSection';

const ContentMarketingArticle = () => {
  useSEO({
    title: 'Content Marketing NYC | SEO Copywriting & Authority Building',
    description: 'Premium SEO content marketing in NYC. We create high-authority, semantically rich articles that build trust and dominate search rankings.',
  });

  return (
    <div className="pt-20 pb-24 bg-slate-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <SectionHeading 
            subtitle="Authority & Trust" 
            title="Strategic Content Marketing for NYC Brands" 
          />
        </AnimatedSection>
        
        <div className="prose prose-invert prose-lg max-w-none text-slate-300 space-y-8">
          <p className="text-xl text-white font-medium leading-relaxed">
            Content is the currency of SEO. In New York City, your content must be more than just informative—it must be the definitive authority on the subject.
          </p>

          <section>
            <h3 className="text-2xl font-bold text-white mb-4">Semantic Content Architecture</h3>
            <p>
              We don't just write for keywords; we write for "topics." Using advanced semantic analysis, we build content hubs that cover every aspect of your industry, signalling to Google that you are an expert in your field (E-E-A-T).
            </p>
          </section>

          <div className="grid md:grid-cols-2 gap-8 my-12">
            <div className="glass-panel p-6 rounded-xl border border-slate-700">
              <h4 className="text-white font-bold mb-2">Engaging the NYC Audience</h4>
              <p className="text-sm">New Yorkers are fast-paced and discerning. We create punchy, high-value content that respects their time and provides immediate utility.</p>
            </div>
            <div className="glass-panel p-6 rounded-xl border border-slate-700">
              <h4 className="text-white font-bold mb-2">Backlink Magnetism</h4>
              <p className="text-sm">High-quality content naturally earns links. We focus on data-driven studies and unique insights that other NYC publications want to reference.</p>
            </div>
          </div>

          <section>
            <h3 className="text-2xl font-bold text-white mb-4">Our Content Philosophy</h3>
            <p>
              Every piece of content we produce serves a double purpose: it satisfies the search engine's need for relevance and the user's need for a solution. From blog posts to whitepapers, we ensure your brand's voice is heard above the noise.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ContentMarketingArticle;